<template>
	<!-- <div class="offline-status" v-tooltip="'Some functions may not work correctly when you are offline'"> -->
		<!-- <span class="dot va-m mr-2"></span> -->
		<!-- <span class="va-m">{{ $t('You seems to be offline') }}</span> -->
		<!-- <span class="va-m">{{ $t('No Internet Connection') }}</span> -->
	<!-- </div> -->
	<div class="modals">
			<!-- Offline -->
			<modal
				class="offline-modal"
				size="small-medium"
				@close="isOffline = false"
				v-if="isOffline">
				<template slot="header">
					<h5 class="mb-0">{{ $t('Connection Problem') }}</h5>
				</template>
				<template slot="body">
					<div class="text-center">
						<p class="material-icons-warning md-18 text-center">warning</p>
					</div>
					<p class="mb-2 text-center text-base">{{ $t('You seems offline, please check your connection') }},</p>
					<p class="mb-4 text-center text-sm">{{ $t('Try to refresh, if the problem persist please contact our support') }}</p>
					<div class="text-center">
						<button
							@click="refreshPage"
							type="submit"
							class="btn btn-submit btn-primary text-center"
							:class="{ 'is-loading': isLoggingIn }">
							{{ $t('Refresh') }}
						</button>
					</div>
				</template>
				<div slot="footer" class="text-center">
				</div>
			</modal>
		</div>
</template>

<script>
import Modal from '@/components/Modal.vue';

export default {
	name: 'OfflineStatus',
	components: {
		Modal,
	},
	data() {
		return {
			isOffline: true,
		};
	},
	methods: {
		refreshPage() {
			window.location.reload();
		},
	},
};
</script>

<style lang="scss">
	.wrapper-offline{
		text-align: center!important;
	}
	.offline-status {
		position: fixed;
		left: 1.25em;
		bottom: 3.5em;
		padding: 1em;
		font-size: .85em;
		border-radius: 2em;
		background-color: #fff;
		box-shadow: 1px 1px 12px rgba(0, 0, 0, 0.1);
		z-index: 9999 !important;

		.dot {
			background-color: #ff6961;
			// background-color: #FE4C4C;
		}
	}
	.material-icons-warning {
    font-family: 'Material Icons';
    font-weight: normal;
    font-style: normal;
    font-size: 80px;
	color: #FFA800;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    -webkit-font-feature-settings: 'liga';
    -webkit-font-smoothing: antialiased;
}
</style>
